import { render, staticRenderFns } from "./accountOPPO.vue?vue&type=template&id=73192642"
import script from "./accountOPPO.vue?vue&type=script&lang=js"
export * from "./accountOPPO.vue?vue&type=script&lang=js"
import style0 from "./accountOPPO.vue?vue&type=style&index=0&id=73192642&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports